export const CurrentUserCompanyInfo = (_class: any) =>
	class extends _class {
		protected currentCompany: { id?: number; razonSocial?: string } = {};
		public esOperadorSistema: boolean;

		constructor() {
			super();
		}

		protected setCurrentUserCompanyInfo(setAdditionalInfo?: boolean) {
			this.authService.getUserCompany();
			this.authService.userCompany.subscribe(
				(empresa: { id?: number; razonSocial?: string }) => {
					this.currentCompany = empresa;
					if (setAdditionalInfo) {
						this.setCurrentCompany();
					}
				}
			);
		}

		protected getSystemOperator() {
			if (this.authService.isSystemOperator !== undefined) {
				this.esOperadorSistema = this.authService.isSystemOperator || false;
			}
		}
	};
